import {useState} from 'react';
import pick from 'lodash/pick';

import Container from '@mui/material/Container';

import CustomBox from '../common/CustomBox';
import PatientWaysToBook from './PatientWaysToBook';

const getSteps = ({prev, next}) => [
  {
    key: 'searchMethod',
    name: 'searchMethod',
    layout: 'row',
    searchMethod: null,
    Component: PatientWaysToBook,
    onSubmit: () => {
      next();
    },
  },
  {
    searchMethod: 'PREVIOUS_PROVIDER',
  },
  {
    searchMethod: 'BY_AVAILABILITY',
  },
  {
    searchMethod: 'BROWSE_PROVIDERS',
  },
];

const filterStepsForMethod = searchMethod => step => (
  step?.searchMethod 
  ? step.searchMethod === searchMethod
  : true
);

const ExistingPatientBookingForm = props => {
  const [stepIndex, setStepIndex] = useState(
    props?.stepIndex ? props.stepIndex 
    : props?.searchMethod ? 1
    : 0
  );
  const [searchMethod, setSearchMethod] = useState(props?.searchMethod || null);
  const steps = getSteps({
    next: () => setStepIndex(Math.min(steps.length - 1, stepIndex + 1)),
    prev: () => setStepIndex(Math.max(0, stepIndex - 1)),
  })
    .filter(filterStepsForMethod(searchMethod));
  const step = steps[stepIndex || 0];
  const childProps = {
    ...pick(step, ['key', 'name', 'layout']),
  };
  return (
    <Container maxWidth='xs' align='center' mt={2}>
      <CustomBox p={2}>
        <step.Component {...childProps} />
      </CustomBox>
    </Container>
  );
};

ExistingPatientBookingForm.defaultProps = {
  stepIndex: 0,
};

export default ExistingPatientBookingForm;